export default {
  title: 'Persönliche Informationen',
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    personal_info_updated_successfully: 'Deine Informationen wurden erfolgreich gespeichert.',
  },
};
